/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './mobile_staff';
import './employee';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "CreatorDetails": {
            "fields": {
              "readOnlyMobileStaff": {
                "type": ".squareup.client.MobileStaff",
                "id": 1,
                "rule": "optional"
              },
              "employee": {
                "type": ".squareup.client.Employee",
                "id": 2,
                "rule": "optional"
              },
              "deviceCredential": {
                "type": ".squareup.client.DeviceCredential",
                "id": 3,
                "rule": "optional"
              },
              "sourceAppId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "DeviceCredential": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.CreatorDetails && !$root.nested?.squareup?.nested?.client?.nested?.DeviceCredential) {
  $root.addJSON(jsonData);
}

/**
 * Only one of these fields may be set.
 *
 * SOURCE CreatorDetails @ squareup/client/creator_details.proto at 16:1
 */
export const CreatorDetails = $root.lookupType('squareup.client.CreatorDetails');
fixType(CreatorDetails);
Builder.createAndAttachToType(CreatorDetails);
/**
 * SOURCE DeviceCredential @ squareup/client/creator_details.proto at 42:1
 */
export const DeviceCredential = $root.lookupType('squareup.client.DeviceCredential');
fixType(DeviceCredential);
Builder.createAndAttachToType(DeviceCredential);